var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1934 9.95338C11.8201 11.32 9.85339 11.74 8.12672 11.2L4.98672 14.3334C4.76006 14.5667 4.31339 14.7067 3.99339 14.66L2.54006 14.46C2.06006 14.3934 1.61339 13.94 1.54006 13.46L1.34006 12.0067C1.29339 11.6867 1.44672 11.24 1.66672 11.0134L4.80006 7.88005C4.26672 6.14671 4.68006 4.18005 6.05339 2.81338C8.02006 0.846712 11.2134 0.846712 13.1867 2.81338C15.1601 4.78005 15.1601 7.98671 13.1934 9.95338Z",
    stroke: "#68717B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59338 11.6602L6.12672 13.1935",
    stroke: "#68717B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66663 7.3335C10.2189 7.3335 10.6666 6.88578 10.6666 6.3335C10.6666 5.78121 10.2189 5.3335 9.66663 5.3335C9.11434 5.3335 8.66663 5.78121 8.66663 6.3335C8.66663 6.88578 9.11434 7.3335 9.66663 7.3335Z",
    stroke: "#68717B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.aba847ee9ebd64ec976620fa70b458b4.svg";
export { ForwardRef as ReactComponent };